import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Location } from '@angular/common';
import { RouteEnum } from '@app/enums/_index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  standalone: false,
})
export class FeedbackComponent implements OnInit, AfterViewInit, OnDestroy {
  locationPath = '';
  splitLocation: Array<string> = [];
  isAiEssentialsPage = false;
  isVoucherPage = false;
  subs: Subscription[] = [];

  constructor(private router: Router, private location: Location) {}

  /**
   * OnInit getting the request url
   */
  ngOnInit(): void {
    this.onPageLoad();
  }

  /**
   * Main app AfterViewInit
   */
  ngAfterViewInit(): void {
    this.onPageLoad();
  }

  /**
   * On Page load for router events
   */
  onPageLoad(): void {
    this.subs.push(
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.locationPath = evt.urlAfterRedirects;
          this.setPage();
        }
      })
    );
    if (this.locationPath == '') {
      this.locationPath = this.location.path();
      this.setPage();
    }
  }

  /**
   * Setting the feedback component for home pages or voucher page
   */
  setPage(): void {
    if (this.locationPath) {
      this.splitLocation = this.locationPath.split('/');

      this.isVoucherPage = this.locationPath.includes(`/${RouteEnum.VOUCHER_REDEMPTION}`);
      this.isAiEssentialsPage = this.locationPath.includes('/subscription/ai-essentials');
    }
  }

  /**
   * On Destroy, unsubscribe subscriptions to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
